<template>
  <div class="container__content">
    <div class="wrapper">
      <div class="content-7">
        <LotteryItem
          :lottery-code="lotteryCode"
          @complete="reload"
        />
      </div>

      <div class="content-8">

        <div class="content-8__titlebar">
          <div class="content-8__titlebar__left">
            <div class="c8-titlename"><span class="c8-titlename__text" v-text="`杀号计划 (已杀${killedCount}期)`"></span></div>
          </div>
          <div class="content-8__titlebar__right">
            <div class="fn-wrap">
              <a class="button-outline c8-datebox__item" @click.prevent="openDescription">
                <span class="button-outline__text">帮助说明</span>
              </a>
            </div>

            <LotteryDateFilterTab
              @updateForm="updateForm"
            />
          </div>
        </div>

        <Loading v-if="isLoading" />
        <div v-if="list.length > 0 && !isLoading">
          <div class="content-8__controlbar__item">
            <div class="c8-select">
              <div class="c8-select__content">
                <a
                  v-for="hm in computedHmList"
                  :key="`hm-selector-${hm.key}`"
                  class="button-outline c8-select__content__item"
                  :class="{ active: hm.key === currentHm }"
                  href="javascript:;"
                  @click="currentHm = hm.key"
                >
                  <span class="button-outline__text" v-text="hm.label"></span>
                </a>
              </div>
            </div>
          </div>

          <div class="content-8__content">
            <table class="even-color">
              <!-- 殺號計畫 -->
              <thead>
                <tr>
                  <th><span>期号</span></th>
                  <th><span>开奖结果</span></th>
                  <th v-for="expert in computedExpertList" :key="`header-expert-${expert.expertID}`" colspan="2">
                    <span v-text="expert.expertName"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="`item-${item.period}`">
                  <td><span v-text="`${item.period.slice(-6)}期`"></span></td>
                  <td>
                    <div v-if="item.balls === null" class="tableballbox">
                      <div class="tableballbox__item">
                        <span class="red">等待开奖</span>
                      </div>
                    </div>
                    <div class="tableballbox">
                      <div
                        v-for="(ball, ballIndex) in item.balls ? item.balls : []"
                        :key="`${item.period}-${ball}-${ballIndex}`"
                        class="tableballbox__item"
                      >
                        <div
                          class="ball size-middle"
                          :class="ball.ballClass"
                        >
                          <span class="ball__number" v-text="ball.label"></span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td
                    v-for="(expert, expertIndex) in item.experts"
                    :key="`${item.period}-expert-${expertIndex}`"
                    :class="{ 'bg-red': expert.type === 'result' && expert.data === 2 }"
                  >
                    <template v-if="expert.type === 'data'">
                      <span
                        :class="{
                          red: expert.data.win === 2,
                          blue: expert.data.win === 3
                        }"
                        v-text="`杀:${expert.data.predictions.join(', ')}`"
                      ></span>
                    </template>
                    <template v-else-if="expert.type === 'result'">
                      <div>
                        <span v-if="expert.data === 2">杀对</span>
                        <span v-else-if="expert.data === 3" class="blue">杀错</span>
                        <span v-else>-</span>
                      </div>
                    </template>
                  </td>
                </tr>
              </tbody>
              <!-- 成績統計 -->
              <thead>
                <tr>
                  <th colspan="2">
                    <span>成绩统计</span>
                  </th>
                  <th v-for="expert in computedExpertList" :key="`header-2-expert-${expert.expertID}`" colspan="2">
                    <span v-text="expert.expertName"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colspan="2"><span>杀对次数</span></td>
                  <td
                    v-for="expert in computedExpertList"
                    :key="`杀对次数-expert-${expert.expertID}`"

                    colspan="2"
                  >
                    <span v-text="`${expert.winCount + expert.loseCount}期 对 ${expert.winCount}期`"></span>
                  </td>
                </tr>
                <tr>
                  <td colspan="2"><span>成功概率</span></td>
                  <td
                    v-for="expert in computedExpertList"
                    :key="`成功概率-expert-${expert.expertID}`"

                    colspan="2"
                  >
                    <span v-text="`${expert.winLoseRatio}%`"></span>
                  </td>
                </tr>
              </tbody>
            </table>
            <ClickMoreBtn v-if="moreBtnExists" :btn-hide="noMoreData" @show-more="showMoreInfo" />
          </div>
        </div>

        <NoData v-if="list.length === 0 && !isLoading" />
      </div>
    </div>
  </div>
</template>

<script>
import { getShJhList_mobile } from '@/api/mobile/shJh'
import { getExpertMap } from '@/api/public/shJh'
import { hmList } from '@/utils/flyc-temp/lotteryLib'

import LotteryItem from '@/components/web/pages/trend/LotteryItem'
import LotteryDateFilterTab from '@/components/web/pages/trend/LotteryDateFilterTab'
import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
import ClickMoreBtn from '@/components/web/pages/trend/ClickMoreBtn'
import chunk from 'lodash.chunk'

export default {
  name: 'WebShJh', // 殺號計畫
  components: {
    LotteryItem,
    LotteryDateFilterTab,
    Loading,
    NoData,
    ClickMoreBtn
  },
  async asyncData({ app, params }) {
    const { lottery_code } = params
    const lotteryType = await app.$getLotteryType(lottery_code)

    return { lotteryType }
  },
  data() {
    return {
      isLoading: true,

      lotteryCode: this.$route.params.lottery_code,
      lotteryType: '',

      expertMap: {},
      expertList: [],

      currentHm: 'hm1',

      currentDate: new Date(),

      form: {
        count: '30'
      },

      killedCount: 0,
      list: [],

      activePanel: 'count',

      hmShow: false,
      countShow: false,
      dateShow: false,

      // 右上角的問號
      rulePopup: {
        popupIsOpen: false,

        isPredict: true,
        predictType: 'shjh'
      },
      chunkInfo: {
        lists: [],
        index: 0,
        last: 0,
        isLast: false
      }
    }
  },
  computed: {
    ...hmList,

    isEmpty() {
      return this.list.length === 0
    },

    computedHmList() {
      switch (this.lotteryType) {
        case 'k3':
          return [{
            label: '综合',
            key: 'fuhe'
          }, {
            label: '和值',
            key: 'all'
          }]
        default:
          return this.hmList
      }
    },
    computedExpertList() {
      const list = this.expertList
        .map((expert) => {
          let expertName
          if (!this.expertMap[expert.expertID]) {
            console.warn('ShJh: computedExpertList: expertMap 和expertID 對應失敗!', this.expertMap, expert.expertID)
            expertName = '-'
          } else {
            expertName = this.expertMap[expert.expertID].expertName
          }

          return Object.assign(expert, { expertName })
        })
      return list
    },
    noMoreData() {
      return this.chunkInfo.isLast
    },
    moreBtnExists() {
      return !this.isLoading && this.list.length > 0
    }
  },
  watch: {
    currentHm() {
      this.reload()
    }
  },
  async created() {
    const { lotteryCode } = this

    this.currentHm = this.lotteryType === 'k3' ? 'fuhe' : 'hm1'

    const expertMap = await this.getExpertMap(lotteryCode)
    this.expertMap = expertMap

    this.$store.dispatch('lottery/getLotteryList')
  },
  mounted() {
    window.vm = this
  },
  methods: {
    async getExpertMap(lotteryCode) {
      const [data, error] = await getExpertMap({ lotteryCode })
      if (error) return {}
      return data
    },
    async reload() {
      this.cleanData()
      this.resetChunkInfo()
      this.isLoading = true

      const { lotteryCode, currentHm: field, form } = this

      const [responseData, error] = await getShJhList_mobile(lotteryCode, field, form)

      if (error) return

      const list = responseData.predictions || []
      const killedCount = responseData.killedCount || 0
      const summary = responseData.summary || []
      // 列表部分
      if (Array.isArray(list)) list.forEach((item) => {
        item.waitDraw = item.result === null
        item.resultLabel = item.result !== null ? [item.result] : ['待开']
        item.balls = !item.balls ? null : item.balls.map((ball) => {
          let label = ball
          let ballClass = ''
          switch (this.lotteryType) {
            case 'k3':
              label = ''
              ballClass = `dice-${ball}`
              break
            case '11x5':
            case 'ssc':
              ballClass = 'circle color--blue'
              break
            case 'pk10':
              ballClass = `ball-${ball} ball-0${ball}`
              break
            default:
              console.warn('WebShJh: lotteryType 對應失敗!', this.lotteryType)
          }

          return {
            label,
            ballClass
          }
        })

        const expertList = []
        item.experts.forEach((expert) => {
          expertList.push({
            type: 'data',
            data: expert
          })
          expertList.push({
            type: 'result',
            data: expert.win
          })
        })
        item.experts = expertList
      })

      // 對資料切片，以 "顯示更多" 按鈕來決定資料呈現
      Object.assign(this.chunkInfo, this.chunkData(list))
      this.list = this.chunkInfo.lists[this.chunkInfo.index] || []

      // 統計部分
      if (Array.isArray(summary)) summary.forEach((expert) => {
        const { winCount, loseCount } = expert
        if (winCount === 0 && loseCount === 0) expert.winLoseRatio = '-'
        else {
          const persent = winCount * 100 / (winCount + loseCount)
          expert.winLoseRatio = (Math.round(persent * 10) / 10).toFixed(1)
        }
      })

      this.expertList = (summary || []).slice()

      Object.assign(this, { killedCount })

      this.isLoading = false
    },

    cleanData() {
      this.list = []
      this.expertList = []
      this.killedCount = 0
    },

    updateForm(form) {
      this.form = Object.assign({}, form)
      this.reload()
    },
    openDescription() {
      this.$store.commit('lottery/OPEN_DESCRIPTION', { name: '帮助说明', lotteryCode: '', descriptionType: 'prediction' })
    },
    resetChunkInfo() {
      Object.assign(this.chunkInfo, { lists: [], index: 0, last: 0, isLast: false })
    },
    chunkData(data) {
      const lists = chunk(data, 31)
      const index = 0
      const last = lists.length - 1
      const isLast = index >= last
      return { lists, index, last, isLast }
    },
    showMoreInfo() {
      const { last, lists } = this.chunkInfo
      this.chunkInfo.index++
      if (this.chunkInfo.index === last) {
        this.chunkInfo.isLast = true
      }
      this.list = this.list.concat(lists[this.chunkInfo.index])
    }
  }
}
</script>

<style scoped>
.fn-wrap {
  height: 100%;
  display: flex;
  align-items: center;
  padding-right: 16px;
  margin-right: 16px;
  border-right:solid 1px #EBEBEB
}
</style>

